// extracted by mini-css-extract-plugin
export default {"item":"FriendListItem_item__LJ5SH","status":"FriendListItem_status__cooP1","green":"FriendListItem_green__VaTqY","red":"FriendListItem_red__D+0A9"};